var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Fingerprint from 'fingerprintjs';
import Api from '../model/api';
import { decorator } from '../utils/instance';
import Emitter from '../utils/emitter';
import sleep from '../utils/sleep';
var syncKey = 'im';
var MAX_RETRY_TIMES = 5;
var RETRY_INTERVAL = 1000;
var MAX_RECONNECT_TIMES = 10;
var RECONNECT_INTERVAL = 5000;
function createBrowserId() {
    var tabId = Math.floor(Math.random() * 899 + 100);
    var browserId = new Fingerprint({
        screen_resolution: true,
        canvas: true,
    }).get();
    browserId = browserId.toString().substr(0, 11);
    browserId += new Array(11 - browserId.length).join('0');
    return browserId + "_" + tabId;
}
var ACCSModule = (function (_super) {
    __extends(ACCSModule, _super);
    function ACCSModule(config) {
        var _this = _super.call(this) || this;
        _this._conn = null;
        _this.retryCount = 0;
        _this.reconnectCount = 0;
        _this.isSessionTimeout = false;
        _this.keepAlive = true;
        _this.windowId = createBrowserId();
        _this.config = config;
        _this._api = Api.getInstance(config);
        if (config.accsKeepAlive !== undefined) {
            _this.keepAlive = config.accsKeepAlive;
        }
        var accs = _this.config.accs;
        if (accs && accs.init) {
            _this._accs = accs;
        }
        else if (window.lib && window.lib.accs) {
            _this._accs = window.lib.accs;
        }
        else {
            throw new Error('config.accs or window.lib.accs must be required!');
        }
        return _this;
    }
    ACCSModule.prototype.init = function () {
        var _this = this;
        return this._accsInit().then(function (conn) {
            _this._conn = conn;
            _this._bindOnMessage();
            console.log('accs 连接成功', _this.retryCount);
            _this.emit('accsConnection', _this.retryCount);
        });
    };
    ACCSModule.prototype.reinit = function () {
        var _this = this;
        this.retryCount = 0;
        return this.close().then(function () {
            _this.reconnectCount = 0;
            return _this.init();
        });
    };
    ACCSModule.prototype._accsInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, conn, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.retryCount >= MAX_RETRY_TIMES) {
                            this.emit('error', { flag: 'notLogin' });
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 7]);
                        return [4, this.getAccsToken()];
                    case 2:
                        token = _a.sent();
                        if (!token) return [3, 4];
                        return [4, this._accs.init({
                                aserverProxy: this.config.accsAserverUrl,
                                appkey: this.config.appKey,
                                heartbeat: true,
                                timeout: 10000,
                                ports: window.location.protocol === 'https:' ? 443 : 80,
                                accsToken: token,
                            })];
                    case 3:
                        conn = _a.sent();
                        this.retryCount = 0;
                        return [2, Promise.resolve(conn)];
                    case 4: return [3, 7];
                    case 5:
                        ex_1 = _a.sent();
                        this.retryCount += 1;
                        return [4, sleep(RETRY_INTERVAL)];
                    case 6:
                        _a.sent();
                        return [2, this._accsInit()];
                    case 7: return [2];
                }
            });
        });
    };
    ACCSModule.prototype._parseMessage = function (resp) {
        return __awaiter(this, void 0, void 0, function () {
            var data, text;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(resp.compressType === 'GZIP')) return [3, 2];
                        return [4, resp.getBinaryArray()];
                    case 1:
                        data = _a.sent();
                        text = Array.prototype.map.call(data, function (c) { return String.fromCharCode(c); }).join('');
                        return [2, Promise.resolve(decodeURIComponent(text))];
                    case 2: return [2, Promise.resolve(decodeURIComponent(resp.getText()))];
                }
            });
        });
    };
    ACCSModule.prototype._processMessage = function (msg) {
        try {
            msg = JSON.parse(msg);
            var syncBody = msg.syncBody || {};
            var syncId = void 0;
            if (msg.syncMsgType === 1) {
                syncId = parseInt(syncBody.typeAndIdMap[syncKey]);
            }
            if (syncId) {
                this.emit('sync', syncId, syncBody);
            }
        }
        catch (err) {
            console.error(err);
        }
    };
    ACCSModule.prototype._bindOnMessage = function () {
        var _this = this;
        if (!this._conn) {
            return;
        }
        this._conn.onMessage(this.config.serviceId, function (resp) { return __awaiter(_this, void 0, void 0, function () {
            var msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._parseMessage(resp)];
                    case 1:
                        msg = _a.sent();
                        this._processMessage(msg);
                        return [2];
                }
            });
        }); });
        this._conn.onError = function () {
            _this.reConnection();
        };
        this._conn.onClose = function () {
            _this.reConnection();
        };
    };
    ACCSModule.prototype.getAccsToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.config;
                        return [4, this._api.request(config._url.accsToken, {
                                accsAppKey: config.accsAppKey,
                                accessKey: config.accessKey,
                                accessToken: config.accessToken,
                                windowId: this.windowId,
                            })];
                    case 1:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.result];
                }
            });
        });
    };
    ACCSModule.prototype.reConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emit('reconnecting');
                        if (!this.keepAlive) {
                            return [2];
                        }
                        if (this.reconnectCount >= MAX_RECONNECT_TIMES) {
                            console.log("reconnect count is " + this.reconnectCount);
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4, this.reinit()];
                    case 2:
                        _a.sent();
                        this.emit('reconnected');
                        return [3, 5];
                    case 3:
                        error_1 = _a.sent();
                        return [4, sleep(RECONNECT_INTERVAL)];
                    case 4:
                        _a.sent();
                        this.reconnectCount++;
                        this.reConnection();
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    ACCSModule.prototype.close = function () {
        if (this._conn && this._conn.getStatus()) {
            this._conn.close();
        }
        return Promise.resolve();
    };
    ACCSModule = __decorate([
        decorator
    ], ACCSModule);
    return ACCSModule;
}(Emitter));
export default ACCSModule;
